import { createSlice } from "@reduxjs/toolkit";
import { getStoredUser } from "../utils/storedUser";

const userLoggedFromLStore = getStoredUser();

const initialState = {
  mode: "dark",
  userStore: {
    user: userLoggedFromLStore,
  },
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
  },
});

export const { setMode } = globalSlice.actions;

export default globalSlice.reducer;